jQuery('#ofstedReportsSlider').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: jQuery(".ofsted-reports-slider-prev"),
    nextArrow: jQuery(".ofsted-reports-slider-next"),
    responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 1100,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                centerPadding: '50px',
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '5px',
            }
        },
    ]
});